import React, { useEffect } from 'react';
import './TTS.css'

function TTS() {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#E3b590'
  }, []);

  return (
    <div className="TTSPage">
      <div>
        <h1 className="Title" >Text to Speech</h1>
      </div>
      <div className="TTSInfo">
        <p> We are currently building a Text To Speech System that will
          synthesize text into spoken Blackfoot.</p>
        <p> We hope to be able to create accurate auditory representations of
          the Blackfoot language.</p>
        <p>This Text To Speech system has a number of applications including
          use in our language teaching robot and in online translators.</p>
      </div>
    </div>
  );
}

export default TTS;
